import { useMemo } from "react";
import useSWRCountrys from "./useSWRCountrys";
import useIntlStore from "@/stores/useIntlStore";
import { getIsOversea } from "../environmentUtils";

const isOversea = getIsOversea();

const PASS_KEY = "CN100000";
const useCountryEnums = () => {
  const countrys = useSWRCountrys();

  const { locale } = useIntlStore();

  const data = useMemo(() => {
    const map = new Map();

    for (const country of countrys) {
      if (
        (!isOversea && country.componentCode !== PASS_KEY) ||
        (isOversea && country.componentCode === PASS_KEY)
      ) {
        continue;
      }
      map.set(country.componentCode, {
        text: locale === "zh-CN" ? country?.nameZh : country?.name,
      });
    }

    return map;
  }, [countrys, locale]);

  return data;
};
export default useCountryEnums;
